import * as React from 'react';
import { MdMoreHoriz } from 'react-icons/md';
import { DropdownMenuProps } from './types';
import { DropdownMenu } from './dropdown-menu';
import styles from './meatball-menu.scss';

export interface MeatballMenuProps extends DropdownMenuProps {
  className?: string;
}

export class MeatballMenu extends React.Component<React.PropsWithChildren<MeatballMenuProps>, any> {
  public render() {

    return <div className={`${styles.meatballDropdownWrapper} ${this.props.className ? this.props.className : ''} meatball-menu`}>
      <DropdownMenu dropdownNode={<MdMoreHoriz />} {...this.props} />
      </div>;
  }
}
